import script from "./FullBleedSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullBleedSection.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__